/**
 * API configuration module.
 * Manages API endpoints and credentials via environment variables.
 */

/**
 * API configuration interface.
 */
export interface ApiConfig {
  /** Mapbox API access token */
  mapboxToken: string;
  /** Base URL for Mapbox Isochrone API */
  isochroneApiUrl: string;
}

/**
 * Gets API configuration from environment variables.
 * @returns API configuration object
 * @throws Error if required environment variables are missing
 */
export function getApiConfig(): ApiConfig {
  const mapboxToken = import.meta.env.VITE_MAPBOX_TOKEN;

  if (!mapboxToken) {
    throw new Error(
      'VITE_MAPBOX_TOKEN is required. Please set it in your .env.local file.'
    );
  }

  return {
    mapboxToken,
    isochroneApiUrl: 'https://api.mapbox.com/isochrone/v1/mapbox',
  };
}

